import LineString from 'ol/geom/LineString';

import type { SketchCoordType } from 'ol/interaction/Draw';
import type { Coordinate } from 'ol/coordinate';

export class Line extends LineString {

  override clone (): Line {
    return lineGeometryFunction(this.flatCoordinates.slice());
  }

}

// Creates a line geometry from coordinates.
export function lineGeometryFunction (coordinates: SketchCoordType, geometry?: Line): Line {
  if (geometry) {
    geometry.setCoordinates(coordinates as Coordinate[]);
    return geometry;
  } else {
    const flatCoordinates = coordinates as number[];
    return new Line(flatCoordinates);
  }
}
